export const resolveAssetPath = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  const trimmed = value.trim();

  if (!trimmed) {
    return '';
  }

  if (
    /^(?:[a-z]+:)?\/\//i.test(trimmed) ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }

  return trimmed.startsWith('/') ? trimmed : `/${trimmed.replace(/^\/+/, '')}`;
};

export const sortByOrderThenId = (left, right) => {
  const leftOrder = Number(left?.order ?? 0);
  const rightOrder = Number(right?.order ?? 0);

  if (leftOrder !== rightOrder) {
    return leftOrder - rightOrder;
  }

  return Number(right?.id ?? 0) - Number(left?.id ?? 0);
};

export const sortByIdDesc = (left, right) => Number(right?.id ?? 0) - Number(left?.id ?? 0);
